import React, { memo } from 'react';
import styled, { css } from 'styled-components';

import colors from '@front/common/src/utils/colors';
import { toRem } from '@front/common/src/utils/styles';

import { HiddenInput } from '../utils';
import { getGradient } from '../../styles/gradient';

const OUTER_RADIUS = 12.5;
const INNER_RADIUS = 4.5;
export const CIRCLE_SIZE = OUTER_RADIUS * 2;

const checkedStyle = css`
  background: ${getGradient()};
  border: none;

  &::before {
    display: block;
    content: '';
    margin: auto;
    width: ${toRem(INNER_RADIUS * 2)};
    height: ${toRem(INNER_RADIUS * 2)};
    background-color: ${colors.white100};
    border-radius: ${toRem(INNER_RADIUS)};
  }
`;

const Container = styled.div`
  margin-right: ${toRem(15)};
`;

const Circle = styled.div<{ $checked: boolean }>`
  display: flex;
  border: ${toRem(1)} solid ${colors.ink50};
  width: ${toRem(CIRCLE_SIZE)};
  min-width: ${toRem(CIRCLE_SIZE)};
  height: ${toRem(CIRCLE_SIZE)};
  border-radius: ${toRem(OUTER_RADIUS)};
  box-sizing: border-box;

  ${(props) => props.$checked && checkedStyle}
`;

export type RadioProps = {
  checked: boolean;
  className?: string;
  id: string;
  name: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  value: string;
};

const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ checked, className, id, name, onChange, value }, ref) => (
    <Container className={className}>
      <HiddenInput
        ref={ref}
        checked={checked}
        data-testid={id}
        id={id}
        name={name}
        onChange={onChange}
        type='radio'
        value={value}
      />
      <Circle $checked={checked} />
    </Container>
  ),
);

export default memo(Radio);
